import React, {Component} from 'react';
import {StyledButton} from "../components/Buttons";
import {withRouter, Link} from "react-router-dom";
import styled from 'styled-components'

import bgJPG from '../static/img/bg/home1.jpg'
import bgWEBP from '../static/img/bg/home.webp'

import partnerSVG from '../static/img/findmepartner.svg'
import {LoginButton} from "../components/Buttons/LoginButton/LoginButtonComponent";
import {LOGIN_URL, REGISTER_URL} from "../constants/URLS";

const BgDiv = styled.div`
background-image: url("${bgJPG}");
width: 100vw;
min-height: 100vh;
background-repeat: no-repeat;
background-position: center center;
background-size: cover;

.partnerLogo{
width: 80%;
top: 50%;
left: 50%;
transform: translate(-50% , 0);
position: absolute;
}
.loginBtn{
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50% , 0);
}
.signUpBtn{
    top: 80%;

}
`


class Home extends Component {
    render() {
        return (
            <BgDiv>
                <img src={partnerSVG} alt="partner" draggable={false} className={'partnerLogo'}/>
                <Link to={LOGIN_URL}>
                    <LoginButton className={'loginBtn'}>Belepes</LoginButton>
                </Link>
                <Link to={REGISTER_URL}>
                    <LoginButton className={'loginBtn signUpBtn'}>Regisztralas</LoginButton>
                </Link>
            </BgDiv>
        );
    }
}

export default withRouter(Home);